<template>
   <div class="warp">
      <div class="list">
         <van-list @load="onLoad" v-model="loadFinish" :finished="finished">
            <div v-for="(item, index) in list" :key="index">
               <div class="item" @click="goDetail(item)">
                  <p>标题：{{ item.title }}</p>
                  <p>
                     <span>
                        版本号：{{ item.version }}
                     </span>
                     <span style="float: right;">
                        创建时间：{{ item.created_at }}
                     </span>
                  </p>
                  <img src="@/assets/image/my/new.png" v-if="item.read_status == 2">
               </div>
            </div>
         </van-list>

      </div>
      <van-button class="button" color="linear-gradient(-40deg, #44D0C9, #2B71FE)" @click="allRead">全部标记为已读</van-button>
   </div>
</template>
<script>
import {
   logList,
   readLog
} from '@/api/update';
export default {
   data() {
      return {
         list: [],
         loadFinish: false,
         finished: false, //加载完成
         page: 1,
         pageSize: 10,
      }
   },
   created() {
      // this.getList()
   },
   computed: {
   },
   methods: {
      getList() {
         let params = {
            page: this.page,
            per_page: 10,
            source: 2,
         }
         logList(params).then((res) => {
            this.page++
            this.total = res.total
            if (res && res.data && res.data.length > 0) {
               this.list.push(...res.data)
               if (res.data.length < 10) {
                  this.finished = true
               }
               setTimeout(() => {
                  this.loadFinish = false
               }, 200)
            } else {
               this.finished = true
            }
         })
      },
      onLoad() {
         this.loadFinish = true
         this.getList()
      },
      allRead() {
         readLog({ type: 2 }).then((res) => {
            if (res) {
               this.$Toast.success('已读成功')
            }
         })
      },
      goDetail(item) {
         localStorage.setItem('noticeInfo', JSON.stringify(item));
         readLog({ type: 1, id: item.id }).then((res) => {
            this.$router.push({
               path: '/noticeDetail'
            },
            )
         })
      },
   },
}
</script>
<style lang="less" scoped>
.list {
   margin-left: 64px;
   margin-top: 12px;
   height: 67vh;
   overflow-y: scroll;

   .item {
      width: 995px;
      height: 247px;
      background: rgba(254, 254, 254, 0.3);
      border-radius: 5px;
      margin-bottom: 47px;
      box-shadow: 0px 0px 13px 1px rgba(68, 208, 201, 0.35);
      padding: 50px 30px;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #313131;
      position: relative;

      p:nth-child(1) {
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }

      p:nth-child(2) {
         margin-top: 56px;
      }
      img{
         width: 67px;
         position: absolute;
         top: 42px;
         right: 29px;
      }
   }
}

.button {
   margin-top: 92px;
   border: none;
   border-radius: 5px;
   width: 340px;
   height: 100px;
   font-family: Source Han Sans CN;
   font-weight: 500;
   font-size: 36px;
   color: #FFFFFF;
   line-height: 26px;
   margin-left: 421px;
}
</style>
